import { createContext, useContext,useState } from 'react';

export const LocaleContext = createContext();

